// extracted by mini-css-extract-plugin
export var blockedMessage = "_a0-3";
export var blockedOverlay = "_a0-1";
export var fadeIn = "_a0-2";
export var hereLink = "_a0-0";
export var slideUp = "_a0-4";